<!--
 * @Description: 
 * @Version: V1.0.0
 * @Author: 周艳凯 750419898@qq.com
 * @Date: 2024-02-23 17:44:42
 * @LastEditors: 周艳凯 750419898@qq.com
 * @LastEditTime: 2024-07-18 13:55:12
 * @FilePath: video.vue
 * Copyright 2024 Marvin, All Rights Reserved. 
 * 2024-02-23 17:44:42
-->
<template>
  <!-- 播放器 -->
  <div class="vidoeBox" v-if="flogs" @click="close">
    <div class="video"  @click.stop>
      <div class="close">
        <el-button type="danger" circle  @click="close" icon="el-icon-close"></el-button>
      </div>
      <video-player
                ref="videoPlayer"
                class="video-player vjs-custom-skin"
                :playsinline="true"
                :options="playerOptions"
                @timeupdate="onPlayerTimeupdate"
        >
      </video-player>
    </div>
  </div>
</template>


<script>
import { videoPlayer } from "vue-video-player";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  components: {
    videoPlayer,
  },
  data() {
    return {
      flogs: false,
      src: "",
      maxDuration: 60, // 设置允许的最大播放时长（单位：秒）
      playerOptions: {
        language: "zh-CN",
        aspectRatio: "16:9",
        sources: [
          {
            type: "application/x-mpegURL",
            src: "",
          },
        ],
        controlBar: {
          progressControl: {
            seekBar: false,
          },
        },
      },
    };
  },
  methods: {
    onPlayerTimeupdate(event) {
      // // 检查当前播放时间是否超过最大允许时长
      if (event.cache_.currentTime >= this.maxDuration) {
        this.$refs.videoPlayer.player.pause()
        // 可以选择跳回到开始或者显示提示信息
        this.$refs.videoPlayer.player.currentTime(0)
        this.$message.error("视频试听已体验结束,请购买课程继续观看");
      }
    },
    // 设置视频
    setInit(time, src) {
      console.log("我老了？？");
      this.flogs = true;
      this.maxDuration = time
      document.body.classList.add("el-popup-parent--hidden");
      // this.src = src;
      this.playerOptions.sources[0].type = src.indexOf("m3u8") === -1? "video/mp4": "application/x-mpegURL";
      this.playerOptions.sources[0].src = src;
    },
    // 关闭
    close() {
      this.flogs = false;
      document.body.classList.remove("el-popup-parent--hidden");
    },
  },
};
</script>

<style lang="scss" scoped>
.vidoeBox {
  position: fixed;
  z-index: 20;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  .video {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: 1000px;
    margin: 0px auto;
    .close{
      display: flex;
      justify-content: end;
      margin-bottom: 10px;
    }
    video {
      width: 100%;
    }
  }
}
</style>